import { TextField } from '@mui/material'
import React from 'react'
import debounce from '../../../../utils/debounce'

export default function TextInput({ text, onChange, errorMsg }) {
  return (
    <div>
      <TextField
        fullWidth
        multiline
        minRows={3}
        maxRows={10}
        onChange={debounce((e) => onChange(e.target.value))}
      />
      <div className="signal-status">
        {errorMsg}
      </div>
      <style>
        {`
          .signal-status {
            color: var(--red);
            font-size: 1rem;
            margin-top: 0.5rem;
          }
        `}
      </style>
    </div>
  )
}
